import { useSession } from "@outschool/ui-auth";
import _ from "lodash";
import React from "react";

import { definitions } from "../../../../shared/parentDashboard/cardTypes/PreferredTimes";
import {
  PreferredTimeTitleType,
  useCardTitleTranslation
} from "../../../../shared/parentDashboard/cardTypes/useCardTitleTranslation";
import { SeededRandom, seededShuffle } from "../../../../shared/Random";
import SearchListingsCard from "../cards/SearchListingsCard";
import { useParentDashboardSeed } from "../utils";
import * as Topic from "./Topic";

export const type = "times";

export function usePreferredTimeRange(random: () => number) {
  const { currentUser } = useSession();
  const timeRanges = {
    afterschool: currentUser?.details?.timeRangeAfterSchool,
    daytime: currentUser?.details?.timeRangeSchool,
    weekend: currentUser?.details?.timeRangeWeekend
  };

  if (
    Object.values(timeRanges).every(
      value => value === null || value === undefined
    )
  ) {
    // no time preferences
    return null;
  }

  const possibleTimeRanges = _.pickBy(timeRanges, value => value !== false);
  const timeRange = seededShuffle(random, Object.keys(possibleTimeRanges))[0];
  return definitions.find(({ id }) => id === timeRange);
}

export function Component({
  random = Math.random,
  trackingProperties
}: {
  random?: () => number;
  trackingProperties?: Record<string, string | number>;
}) {
  const timeRange = usePreferredTimeRange(random);
  const title = useCardTitleTranslation(
    timeRange?.title as PreferredTimeTitleType
  );
  if (!timeRange) {
    return null;
  }

  return (
    <SearchListingsCard
      id={timeRange.id}
      title={title}
      url={timeRange.url}
      searchFilters={timeRange.searchFilters}
      // @ts-ignore TS(2322): Type 'Record<string, string | number> | undefined'... Remove this comment to see the full error message
      trackingProperties={trackingProperties}
      loadAfterDelay={0}
    />
  );
}

export function ListComponent() {
  const seed = useParentDashboardSeed();
  const timeRange = usePreferredTimeRange(SeededRandom(seed));

  // @ts-ignore TS(2322): Type 'PreferredTimesCardDefinition | null | undefi... Remove this comment to see the full error message
  return <Topic.ListComponent card={timeRange} />;
}
